module.exports = __webpack_public_path__ + "b9822b7339b37ef8a8ac4888b7931410.png";